import { Switch } from '@chakra-ui/react';
import { TDropDown } from '@/trio-ui/Dropdown';
import * as Styles from './ScoreInput.styles';

export type ScoreInputProps = Pick<
  TDropDown,
  'name' | 'isDisabled' | 'options' | 'errorMessage'
> & {
  label: string;
  value: string;
  id?: string;
  onChangeInput: (event: any) => void;
  maxScoreValue?: number;
};

const getMaxScoreFromOptions = (isBooleanInput: boolean, options: string[]): number => {
  if (isBooleanInput) {
    return 1;
  }

  return Number(options.at(-1));
};

export default function ScoreInput({
  label,
  value,
  onChangeInput,
  id,
  maxScoreValue,
  ...dropdownProps
}: ScoreInputProps): JSX.Element {
  const isBooleanInput = (dropdownProps.options as string[])?.includes('Yes');

  const maxValue =
    maxScoreValue || getMaxScoreFromOptions(isBooleanInput, dropdownProps.options as string[]);
  const parsedMaxScoreValue = Number(maxValue).toFixed(1);

  const maxScoreLabel = isBooleanInput
    ? ` (${parsedMaxScoreValue})`
    : ` (max: ${parsedMaxScoreValue})`;

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const isChecked = event.target.checked;
    const syntheticEvent = {
      target: {
        name: dropdownProps.name,
        value: isChecked ? 'Yes' : 'No',
      },
    };
    onChangeInput(syntheticEvent);
  };

  const isSwitchChecked = value === 'Yes';

  return (
    <Styles.Box id={id}>
      <Styles.LabelWrapper>
        <Styles.Label>
          {label}
          <Styles.MaxScoreValue>{maxScoreLabel}</Styles.MaxScoreValue>
        </Styles.Label>
      </Styles.LabelWrapper>

      {isBooleanInput ? (
        <Styles.ToggleWrapper>
          <Switch
            isChecked={isSwitchChecked}
            onChange={handleSwitchChange}
            isDisabled={dropdownProps.isDisabled}
            colorScheme="blue"
            size="md"
          />
        </Styles.ToggleWrapper>
      ) : (
        <Styles.DropdownWrapper>
          <Styles.CustomDropdown
            defaultValue={value}
            onChangeDropDown={onChangeInput}
            {...dropdownProps}
          />
        </Styles.DropdownWrapper>
      )}
    </Styles.Box>
  );
}
